/* eslint-disable react-hooks/exhaustive-deps */
import { Link } from "react-router-dom";
import React, { useEffect, useMemo, useState } from "react";
import { useDoSeeDataContext } from "../../../context/doSeeData/DoSeeDataContext";
import { pushOneMusic } from "../../../middlewares/sysNavigation/SysNavigation";
import { BreadCrumbComponent } from "../../../middlewares/breadCrumb/BreadCrumbComponent";
import {
  Modal,
  GoBack,
  MySearch,
  MyButton,
  Pagination,
  ModalPosition,
  DashboardIntro,
} from "../../home/component/Component";
import { _TYPES_ } from "../utils/types";
import { _PAGE_SIZE_ } from "../../../middlewares/other/tools";
import { useGeoPositionContext } from "../utils/geoPosition";
import { useAdminContext } from "../../../context/admin/context/AdminContext";
import { FaRegCheckSquare, FaRegSquare, FaRegTrashAlt } from "react-icons/fa";
import { RiRefreshLine } from "react-icons/ri";

const addRoute = "/data/music/add";
const editRoute = "/data/music/edit";
const doseeDataRoutes = "/dosee/data";

const Overview = () => {
  const [musicList, setMusicsList] = useState([]);
  const { music, musicCount, fetchDoSeeData, deleteOneContent } =
    useDoSeeDataContext();

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(_PAGE_SIZE_);
  const [localSearch, setLocalSearch] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedContentIds, setSelectedContentIds] = useState([]);

  const {
    country_id,
    entry_label,
    first_level_id,
    fourth_level_id,
    second_level_id,
    third_level_id,
  } = useGeoPositionContext();

  const data_request_body = {
    country_id,
    first_level_id,
    second_level_id,
    third_level_id,
    fourth_level_id,
    content: _TYPES_.MUSIC,
  };

  useEffect(() => {
    if (!music) fetchDoSeeData(data_request_body, page, pageSize);
    else setMusicsList(music);
  }, [music]);

  const SearchList = (e) => {
    const key = e.target.value.toString().toLowerCase();
    let searchArray = [];
    music.map((msc) => {
      if (msc?.title.toString().toLowerCase().includes(key))
        return searchArray.push(msc);
      return true;
    });
    setMusicsList(searchArray);
    if (key === "") setMusicsList(music);
  };

  const LocalData = localSearch?.length > 0 ? localSearch : musicList;

  const reloadData = () => fetchDoSeeData(data_request_body, page, pageSize);

  const deleteMany = async () => {
    setLoading(true);
    for (let i = 0; i < selectedContentIds.length; i++) {
      await deleteOneContent({
        data_id: selectedContentIds[i],
        content: _TYPES_.MUSIC,
      });
    }
    setLoading(false);
    reloadData();
  };

  // ---- Select All fix: normalize for comparison, keep original types in state ----
  const selectedSet = useMemo(
    () => new Set(selectedContentIds.map((id) => String(id))),
    [selectedContentIds]
  );
  const pageIds = useMemo(
    () => (LocalData || []).map((row) => String(row?.music_id ?? "")),
    [LocalData]
  );
  const masterSelected = useMemo(
    () => pageIds.length > 0 && pageIds.every((id) => selectedSet.has(id)),
    [pageIds, selectedSet]
  );

  const toggleRow = (row) => {
    const rowId = row?.music_id;
    const rowIdStr = String(rowId);
    if (selectedSet.has(rowIdStr)) {
      setSelectedContentIds((prev) =>
        prev.filter((id) => String(id) !== rowIdStr)
      );
    } else {
      setSelectedContentIds((prev) => [...prev, rowId]); // preserve original type
    }
  };

  const toggleAllOnPage = () => {
    if (masterSelected) {
      // Unselect only current page items
      setSelectedContentIds((prev) =>
        prev.filter((id) => !pageIds.includes(String(id)))
      );
    } else {
      // Add all current page items (avoid duplicates)
      setSelectedContentIds((prev) => {
        const prevSet = new Set(prev.map((id) => String(id)));
        const toAdd = (LocalData || [])
          .map((row) => row?.music_id)
          .filter((id) => !prevSet.has(String(id)));
        return [...prev, ...toAdd];
      });
    }
  };
  // -----------------------------------------------------------------------------

  const container = "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8";
  const card =
    "overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm";
  const sectionPad = "p-4 sm:p-5";
  const btnBase =
    "inline-flex items-center gap-2 px-3.5 py-2.5 rounded-lg border transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:opacity-60 disabled:cursor-not-allowed";
  const btnPrimary =
    "bg-blue-600 text-white border-blue-600 hover:bg-blue-500 focus-visible:ring-blue-500";
  const btnNeutral =
    "bg-white text-slate-700 border-slate-200 hover:bg-slate-50";
  const btnDanger =
    "bg-red-600 text-white border-red-600 hover:bg-red-500 focus-visible:ring-red-500";

  return (
    <div className="h-full overflow-y-auto bg-white">
      <div className={`${container} py-4 lg:py-6`}>
        <div className="mb-4">
          <BreadCrumbComponent />
        </div>

        <div className="flex items-center justify-between mb-2">
          <GoBack props={{ route: doseeDataRoutes }} />
        </div>

        <div className="mb-6">
          <DashboardIntro props={{ intro: `Music`, name: entry_label }} />
        </div>

        <div className="flex flex-col gap-4">
          <div className={`${card} ${sectionPad}`}>
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
              <MySearch
                type={_TYPES_.MUSIC}
                value={localSearch}
                showGlobalSearch={true}
                setValue={setLocalSearch}
                onChange={(e) => SearchList(e)}
              />

              {country_id ? (
                <Link to={addRoute} className="shrink-0">
                  <MyButton
                    title="Add Music"
                    className={`${btnBase} ${btnPrimary}`}
                    onClick={() => { }}
                  />
                </Link>
              ) : null}
            </div>
          </div>

          <div
            className={`${card} ${sectionPad} flex flex-wrap items-center gap-3`}
          >
            <MyButton
              className={`${btnBase} ${btnNeutral}`}
              onClick={toggleAllOnPage}
            >
              {masterSelected ? (
                <FaRegCheckSquare className="text-green-600 text-lg cursor-pointer" />
              ) : (
                <FaRegSquare className="text-slate-700 text-lg cursor-pointer" />
              )}
              <span className="text-slate-700">
                {masterSelected ? "Unselect All" : "Select All"}
              </span>
            </MyButton>

            <MyButton
              onClick={deleteMany}
              className={`${btnBase} ${selectedContentIds?.length > 0 ? btnDanger : btnNeutral
                }`}
              disabled={selectedContentIds?.length === 0 || loading}
            >
              {loading ? (
                <RiRefreshLine className="text-lg animate-spin" />
              ) : (
                <FaRegTrashAlt className="text-base" />
              )}
              <span>
                Delete{" "}
                {selectedContentIds?.length > 0 ? selectedContentIds.length : ""}{" "}
                {selectedContentIds?.length === 1 ? "Item" : "Items"}
              </span>
            </MyButton>
          </div>

          <div className={card}>
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead className="bg-slate-50 text-slate-600">
                  <tr>
                    <th className="px-4 py-3 text-left font-semibold">
                      Select
                    </th>
                    <th className="px-4 py-3 text-left font-semibold">Title</th>
                    <th className="px-4 py-3 text-left font-semibold">Slug</th>
                    <th className="px-4 py-3 text-center font-semibold">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-200">
                  {music || LocalData ? (
                    LocalData?.map((msc, key) => {
                      const isSelected = selectedSet.has(
                        String(msc?.music_id)
                      );
                      return (
                        <tr
                          key={key}
                          className="hover:bg-slate-50 transition-colors"
                        >
                          <td className="px-4 py-3">
                            <MyButton
                              onClick={() => toggleRow(msc)}
                              className={`${btnBase} ${btnNeutral}`}
                            >
                              {isSelected ? (
                                <FaRegCheckSquare className="text-green-600 text-lg" />
                              ) : (
                                <FaRegSquare className="text-slate-700 text-lg" />
                              )}
                            </MyButton>
                          </td>
                          <td className="px-4 py-3">{msc?.title}</td>
                          <td className="px-4 py-3">{msc?.slug}</td>
                          <td className="px-2 py-3">
                            <ActionButton props={msc} />
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr className="animate-pulse">
                      <td className="px-4 py-3">...</td>
                      <td className="px-4 py-3">...</td>
                      <td className="px-4 py-3">...</td>
                      <td className="px-4 py-3">...</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <div className={`${card} ${sectionPad}`}>
            <Pagination
              page={page}
              setPage={setPage}
              pageSize={pageSize}
              setPageSize={setPageSize}
              total_items={musicCount}
              callbackFunction={(p, size) => {
                fetchDoSeeData(data_request_body, p, size);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

/**
 *  @author Ntavigwa Bashombe
 * @param {*} props
 * @returns
 */
const ActionButton = ({ props }) => {
  const { sysAdmin } = useAdminContext();
  const isSuperAdmin = ["super_admin", "admin"].includes(sysAdmin?.role);
  const { music, setDataState, deleteOneContent, updateOneContent } =
    useDoSeeDataContext();

  const [showModal, setShowModal] = useState(false);

  const music_id = props.music_id;
  const music_title = props.title;
  const msc = props;

  const deleteOneMusicById = async (music_id) => {
    const { status } = await deleteOneContent({
      data_id: music_id,
      content: _TYPES_.MUSIC,
    });
    if (status === 200) {
      if (music) {
        setDataState({
          data: music.filter((msc) => msc?.music_id !== music_id),
          content: _TYPES_.MUSIC,
        });
        setShowModal(false);
      }
    }
  };

  const suspension = async (msc) => {
    const data = {
      title: msc?.title,
      city_level: msc?.city_level,
      country_id: msc?.country_id,
      description: msc?.description,
      first_level_id: msc?.first_level_id,
      fourth_level_id: msc?.fourth_level_id,
      hashtag: msc?.hashtag,
      second_level_id: msc?.second_level_id,
      slug: msc?.slug,
      status: msc?.status === 1 ? 0 : 1,
      third_level_id: msc?.third_level_id,
      thumbnail: msc?.thumbnail,
    };

    const { status } = await updateOneContent({
      data_id: msc?.music_id,
      data: data,
      content: _TYPES_.MUSIC,
    });

    if (status === 200) {
      if (music) {
        const array = [];
        music.map((msc) => {
          if (msc?.music_id === music_id)
            return array.push({
              music_id: msc?.music_id,
              created_by: msc?.created_by,
              createdAt: msc?.createdAt,
              updatedAt: msc?.updatedAt,
              ...data,
            });
          else return array.push(msc);
        });
        setDataState({ data: array, content: _TYPES_.MUSIC });
      }
    }
  };

  const [showPosition, setShowPosition] = useState(false);

  const btnBase =
    "inline-flex items-center gap-2 px-3.5 py-2.5 rounded-lg border transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2";
  // const btnNeutral =
  //   "bg-white text-slate-700 border-slate-200 hover:bg-slate-50";
  const btnInfo =
    "bg-blue-700 text-white border-blue-700 hover:bg-blue-600 focus-visible:ring-blue-600";
  const btnWarn =
    "bg-amber-600 text-white border-amber-600 hover:bg-amber-500 focus-visible:ring-amber-500";
  const btnDanger =
    "bg-red-600 text-white border-red-600 hover:bg-red-500 focus-visible:ring-red-500";
  const btnPrimary =
    "bg-blue-600 text-white border-blue-600 hover:bg-blue-500 focus-visible:ring-blue-500";

  return (
    <>
      {showPosition ? (
        <ModalPosition
          name={music_title}
          type={_TYPES_.MUSIC}
          id={music_id}
          setShowPosition={setShowPosition}
          showPosition={showPosition}
        />
      ) : null}

      <Modal
        props={{
          name: music_title,
          showModal: showModal,
          setShowModal: () => setShowModal(false),
          delete: () => deleteOneMusicById(music_id),
        }}
      />

      <div className="flex flex-row justify-end items-center px-2 py-2 gap-2">
        {isSuperAdmin ? (
          <MyButton
            title={msc?.status === 1 ? "Suspend" : "Unsuspend"}
            className={`${btnBase} ${msc?.status === 1 ? btnPrimary : btnWarn}`}
            onClick={() => suspension(msc)}
          />
        ) : null}

        <Link to={editRoute}>
          <MyButton
            title="Edit"
            className={`${btnBase} ${btnInfo}`}
            onClick={() => pushOneMusic(msc)}
          />
        </Link>
        <MyButton
          title="Delete"
          className={`${btnBase} ${btnDanger}`}
          onClick={() => setShowModal(true)}
        />
      </div>
    </>
  );
};

export default Overview;
